/**
 * Route-level loading state. Rendered by the `Suspense` boundary while a lazy
 * page chunk downloads.
 *
 * `<output>` carries an implicit `status` role, so assistive tech announces the
 * change without an explicit `role`/`aria-live` pair.
 */
export function PageSpinner() {
    return (
        <output className="flex min-h-dvh items-center justify-center">
            <span
                aria-hidden="true"
                className="border-line border-t-focus size-8 animate-spin rounded-full border-4"
            />
            <span className="sr-only">Loading…</span>
        </output>
    );
}
